import FieldRenderer from '../Fields/FieldRenderer';

const inlinePopoverFields = ['ckeditor']

const FormRenderer = ({id, index, formIndex, inline, fields, values, onChange, excludeWrapper = false, excludeLabel=false, ref = null, popoverTarget = null}) => {
    if(!fields){
        return
    }
    const form = Object.keys(fields).map( (key) => {
        const field = fields[key]
        return <FieldRenderer
            key={key + "_" + id} 
            fieldKey={key} 
            id={id} 
            popoverTarget={popoverTarget} 
            popover={inline && inlinePopoverFields.includes(field.template)}
            index={index} 
            formIndex={formIndex} 
            inline={inline} 
            field={field} 
            values={values}
            onChange={onChange} 
            excludeLabel={excludeLabel} 
            excludeWrapper={excludeWrapper} 
            ref={ref} 
        />
    })
    return (
        <>
        {form}
        </>
    )
}

export default FormRenderer;